module.exports = __webpack_public_path__ + "static/media/services.820ba01f.jpg";